<!-- Desktop View -->
<nav id="maincontent_searchbar" class="navbar navbar-default hidden-xs" style="margin-bottom:0px">
  <div class="navbar-form" role="search" style="display:inline-block">
    <div class="row">
      <div class="col-lg-12">
        <button
          class="btn btn-primary"
          (click)="toggleAdvanced()"
          title="Toggle Filter Panel">
	          <span class="fas" [ngClass]="{
	            'fa-chevron-left': states?.advancedOpen,
	            'fa-chevron-right': !states?.advancedOpen}"></span>
        </button>

        <div class="input-group">
          <input
            [(ngModel)]="states.query"
            (keypress)="simpleSearch($event)"
            type="search"
            class="form-control"
            [attr.aria-label]="LOCALIZATION?.query"
            [placeholder]="LOCALIZATION?.searchPlaceholder"
            size="35" />
          <div class="input-group-btn query-type-select">
            <select class="form-control" [(ngModel)]="states.type" [attr.aria-label]="LOCALIZATION?.queryType">
              <option value="0">{{LOCALIZATION?.exactMatch}}</option>
              <option value="16">{{LOCALIZATION?.boolean}}</option>
              <option value="32">{{LOCALIZATION?.concept}}</option>
              <option value="64">{{LOCALIZATION?.pattern}}</option>
              <option *ngIf="isMoreLikeThisEnabled" value="3">{{LOCALIZATION?.morelikethis}}</option>
              <option *ngIf="streamingQueries?.enabled" value="stream:7">{{LOCALIZATION?.distance}}</option>
            </select>
          </div>
          <span class="input-group-btn">
            <button class="btn btn-primary" (click)="simpleSearch(undefined)" title="Trigger Search">
              <i class="fas fa-search" aria-hidden="true"></i>
            </button>
          </span>
        </div>
        <button *ngIf="searchResults" (click)="doCleanSearches()" class="btn btn-danger" title="Clear Search">
          <span class="fas fa-times"></span>
        </button>
        <button *ngIf="searchResults && user.loggedin" (click)="saveSearch()" class="btn btn-warning" title="Save this search">
          <i class="fa fa-bookmark"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- View Switch Buttons -->
  <form class="navbar-form navbar-right" style="margin-right:10px;padding:0px 0px">
    <div class="btn-group hidden-sm">
      <label
        title="{{LOCALIZATION?.grid}}"
        class="btn btn-primary custom-viewer-select"
        (click)="changeView('G')"
        [class.active]="states?.currentView === 'G'"
      >
        <span class="fa fa-table"></span>
      </label>
      <label
        *ngIf="!userPermissions['BLOCK_LIST_VIEW']"
        title="{{LOCALIZATION?.list}}"
        class="btn btn-primary custom-viewer-select"
        (click)="changeView('L')"
        [class.active]="states?.currentView === 'L'"
      >
        <span class="fas fa-th-list"></span>
      </label>
      <label
        *ngIf="!userPermissions['BLOCK_THUMBNAIL_VIEW']"
        title="{{LOCALIZATION?.thumbnail}}"
        class="btn btn-primary custom-viewer-select"
        (click)="changeView('T')"
        [class.active]="states?.currentView === 'T'"
      >
        <span class="fa fa-th-large"></span>
      </label>
      <label
        *ngIf="recordsMgmtServicesEnabled && userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW']"
        title="{{LOCALIZATION?.recordsManagement}}"
        class="btn btn-primary custom-viewer-select"
        (click)="changeView('R')"
        [class.active]="states?.currentView === 'R'"
      >
        <span class="fas fa-folder"></span>
      </label>
      <label
        *ngIf="mapViewEnabled && !mapDetached && !userPermissions['BLOCK_MAP_VIEW']"
        title="{{LOCALIZATION?.map}}"
        class="btn btn-primary custom-viewer-select"
        (click)="changeView('M')"
        [class.active]="states?.currentView === 'M'"
      >
        <span class="fas fa-globe-americas"></span>
      </label>
      <label
        *ngIf="simpleview?.enabled"
        title="{{LOCALIZATION?.simpleView}}"
        class="btn btn-primary custom-viewer-select"
        (click)="changeView('S')"
        [class.active]="states?.currentView === 'S'"
      >
        <span class="fa fa-list-alt"></span>
      </label>
    </div>
    
    <div class="col-xs-4 nopads visible-sm">
	  <div class="btn-group" ngbDropdown 
				  #dropdownRef="ngbDropdown"
			    class="dropdown" [autoClose]="'outside'">
	    <button
	      type="button"
	      id="views-button"
	      class="btn btn-primary"
	      ngbDropdownToggle
	      title="Change view">
	      {{ LOCALIZATION?.views }} <span class="caret"></span>
	    </button>
	    <ul class="dropdown-menu custom-drop" ngbDropdownMenu role="menu" aria-labelledby="views-button">
	      <li>
	        <a
	          title="{{ LOCALIZATION?.grid }}"
	          style="z-index:0"
	          (click)="changeView('G',dropdownRef)">
	          {{ LOCALIZATION?.grid }}
	        </a>
	      </li>
	      <li *ngIf="!userPermissions['BLOCK_LIST_VIEW']">
	        <a
	          title="{{ LOCALIZATION?.list }}"
	          style="z-index:0"
	          (click)="changeView('L',dropdownRef)">
	          {{ LOCALIZATION?.list }}
	        </a>
	      </li>
	      <li *ngIf="!userPermissions['BLOCK_THUMBNAIL_VIEW']">
	        <a
	          title="{{ LOCALIZATION?.thumbnail }}"
	          style="z-index:0"
	          (click)="changeView('T')">
	          {{ LOCALIZATION?.thumbnail }}
	        </a>
	      </li>
	      <li *ngIf="recordsMgmtServicesEnabled && userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW']">
	        <a
	          title="{{ LOCALIZATION?.recordsManagement }}"
	          style="z-index:0"
	          (click)="changeView('R')">
	          {{ LOCALIZATION?.records }}
	        </a>
	      </li>
	      <li *ngIf="!userPermissions['BLOCK_MAP_VIEW'] && mapViewEnabled && !mapDetached">
	        <a
	          title="{{ LOCALIZATION?.map }}"
	          style="z-index:0"
	          (click)="changeView('M')">
	          {{ LOCALIZATION?.map }}
	        </a>
	      </li>
	      <li *ngIf="simpleview?.enabled">
	        <a
	          title="{{ LOCALIZATION?.simpleView }}"
	          style="z-index:0"
	          (click)="changeView('S')">
	          {{ LOCALIZATION?.simpleView }}
	        </a>
	      </li>
	    </ul>
	  </div>
	</div>
  </form>
</nav>

<!-- Mobile View -->
<nav *ngIf="userPermissions" class="navbar navbar-default visible-xs">
  <div class="input-group">
    <input
      type="text"
      [(ngModel)]="states.query"
      (keypress)="simpleSearch($event)"
      class="form-control"
      placeholder="Search Terms"
      aria-label="Search Terms"
    />
    <span class="input-group-btn">
      <button type="button" class="btn btn-primary" (click)="simpleSearch(undefined)">
        <span class="fas fa-search"></span>
      </button>
    </span>
    <span class="input-group-btn" *ngIf="searchResults">
      <button type="button" class="btn btn-danger" (click)="newSearch()">
        <span class="fas fa-times"></span>
      </button>
    </span>
    <span class="input-group-btn" *ngIf="searchResults && user.loggedin">
      <button type="button" class="btn btn-warning" (click)="saveSearch()">
        <i class="fa fa-bookmark"></i>
      </button>
    </span>
  </div>
</nav>
